var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "#C3D3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55263 3.52174C7.55263 3.23359 7.30521 3 7 3C6.69479 3 6.44737 3.23359 6.44737 3.52174V10.4783C6.44737 10.7664 6.69479 11 7 11C7.30521 11 7.55263 10.7664 7.55263 10.4783V3.52174ZM10.5 6.30435C10.5 6.0162 10.2526 5.78261 9.94737 5.78261C9.64216 5.78261 9.39474 6.0162 9.39474 6.30435V10.4783C9.39474 10.7664 9.64216 11 9.94737 11C10.2526 11 10.5 10.7664 10.5 10.4783V6.30435ZM4.60526 7.69565C4.60526 7.4075 4.35784 7.17391 4.05263 7.17391C3.74742 7.17391 3.5 7.4075 3.5 7.69565V10.4783C3.5 10.7664 3.74742 11 4.05263 11C4.35784 11 4.60526 10.7664 4.60526 10.4783V7.69565Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.fa8796b052c9b9eaca385a6ea6c53ff9.svg";
export { ForwardRef as ReactComponent };